// ============================================================
// EVERY SPECIAL'S LOOK, BY KEY (plan body-map H3): the elements and accents
// (./elements), the blades and the motions (./blades), the closing effects
// (./closers). A key with no look draws nothing.
// ============================================================

import type { ReactNode } from 'react';
import type { LookCtx } from './kit';
import { ELEMENT_LOOKS } from './elements';
import { BLADE_LOOKS } from './blades';
import { CLOSING_LOOKS } from './closers';
import { Special } from './primitives';

const LOOKS: Record<string, (c: LookCtx) => ReactNode> = { ...ELEMENT_LOOKS, ...BLADE_LOOKS, ...CLOSING_LOOKS };

/** One special at its moment: its look, named for the tests. */
export function SpecialLook({ name, ctx }: { name: string; ctx: LookCtx }) {
  const look = LOOKS[name];
  return look ? <Special name={name}>{look(ctx)}</Special> : null;
}
